import React, { useEffect, useState, useMemo } from "react";
import { getDashboardStats } from "../../../api/register";
import { Table } from "../../../Components/Table/Table";
import toast from "react-hot-toast";

import GroupsIcon from "@mui/icons-material/Groups";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";

import { Pie, Bar } from "react-chartjs-2";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);

const AdminDashboard = () => {
  const [stats, setStats] = useState({});
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      setLoading(true);
      const res = await getDashboardStats();
      setStats(res.data);
      setEmployees(res.data.recentEmployees || []);
    } catch (error) {
      toast.error("Dashboard load failed");
    } finally {
      setLoading(false);
    }
  };

  /* ================= TABLE ================= */
  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        Cell: ({ row }) => <span>{row.index + 1}</span>,
      },
      {
        Header: "Name",
        accessor: (row) => `${row.firstName} ${row.lastName}`,
      },
      {
        Header: "Employee ID",
        accessor: "employeeId",
      },
      {
        Header: "Email",
        accessor: "officialmailid",
      },
      {
        Header: "Status",
        accessor: "status",
      },
    ],
    []
  );

  /* ================= PIE CHART ================= */
  const chartData = {
    labels: ["Pending", "Approved", "Rejected"],
    datasets: [
      {
        data: [
          stats.pendingEmployees || 0,
          stats.approvedEmployees || 0,
          stats.rejectedEmployees || 0,
        ],
        backgroundColor: ["#f6c23e", "#1cc88a", "#e74a3b"],
        borderWidth: 1,
      },
    ],
  };

  /* ================= BAR CHART ================= */
  const barData = {
    labels: ["Pending", "Approved", "Rejected"],
    datasets: [
      {
        label: "Employees",
        data: [
          stats.pendingEmployees || 0,
          stats.approvedEmployees || 0,
          stats.rejectedEmployees || 0,
        ],
        backgroundColor: ["#f6c23e", "#1cc88a", "#e74a3b"],
        borderRadius: 6,
      },
    ],
  };

  const barOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div className="admin-dashboard-wrapper">
      <h2 className="admin-dashboard-title f2">Admin Dashboard</h2>

      {/* ================= STAT CARDS ================= */}
      <div className="admin-dashboard-grid">
        <div className="admin-stat-card blue">
          <div className="card-icon">
            <GroupsIcon />
          </div>
          <h3>{stats.totalEmployees || 0}</h3>
          <p className="f2">Total Employees</p>
        </div>

        <div className="admin-stat-card yellow">
          <div className="card-icon">
            <HourglassBottomIcon />
          </div>
          <h3>{stats.pendingEmployees || 0}</h3>
          <p className="f2">Pending</p>
        </div>

        <div className="admin-stat-card green">
          <div className="card-icon">
            <CheckCircleIcon />
          </div>
          <h3>{stats.approvedEmployees || 0}</h3>
          <p className="f2">Approved</p>
        </div>

        <div className="admin-stat-card red">
          <div className="card-icon">
            <CancelIcon />
          </div>
          <h3>{stats.rejectedEmployees || 0}</h3>
          <p className="f2">Rejected</p>
        </div>
      </div>

      {/* ================= CHART SECTION ================= */}
      <div className="admin-chart-section">
        {/* PIE */}
        <div className="chart-box">
          <h4 className="f2">Status Overview</h4>
          <Pie data={chartData} />
        </div>

        {/* BAR 🔥 */}
        <div className="chart-box">
          <h4 className="f2">Employee Comparison</h4>
          <div style={{ height: "250px" }}>
            <Bar data={barData} options={barOptions} />
          </div>
        </div>
      </div>

      {/* ================= TABLE ================= */}
      <div className="admin-table-section">
        <div className="table-header">
          <h4 className="f2">Recent Employees</h4>
          <button className="view-all-btn f2">View All</button>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="table-card">
            <Table columns={columns} data={employees} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;